import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import connect from 'app/libs/connect';
import ProductCta from 'app/features/landing/components/ProductCta';
import {
  isMultiTier,
  hasSpecialTraits,
  productButtonTextKey,
} from 'app/features/products/selectors';

const UI = ({ textKey, sku, hasSpecialTraits, isMultiTier }) => (
  <ProductCta
    sku={sku}
    isWide
    textKey={textKey}
    type={hasSpecialTraits || !isMultiTier ? 'six' : 'sixWeak'}
    testId="product-comparison-subscription-cta"
  >
    <FormattedMessage id={textKey} />
  </ProductCta>
);

UI.propTypes = {
  sku: PropTypes.string.isRequired,
  textKey: PropTypes.string.isRequired,
  isMultiTier: PropTypes.bool.isRequired,
  hasSpecialTraits: PropTypes.bool,
};

UI.defaultProps = {
  hasSpecialTraits: false,
};

UI.displayName = 'PaidProductButton';

const state = {
  textKey: productButtonTextKey,
  hasSpecialTraits,
  isMultiTier,
};

const PaidProductButton = connect(state)(UI);

export { UI };

export default PaidProductButton;
